module.exports = __webpack_public_path__ + "static/media/k-enroll.156532fc.svg";